module.exports = __webpack_public_path__ + "static/media/g-suite-banner.2b4625fd.png";